import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-summarize-data-list',
  templateUrl: './summarize-data-list.component.html',
  styleUrls: ['./summarize-data-list.component.scss'],
  standalone: false
})
export class SummarizeDataListComponent {

  @Input() summary: any;


  changeNewLine(bot: any): string {
    const text = typeof bot === 'string'
      ? bot
      : bot?.bot_answer ?? '';

    return text.replace(/\r\n?|\n/g, '<br>');
  }

}
